import { POIDeveloperSticky } from './poi-developer-sticky';

export default POIDeveloperSticky;
